<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        <span style="color:#0cabc2">Customers</span>
      </v-toolbar-title>

      <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="primary" dark class="mb-2">New Customer</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 lg12 xl12>
                  <v-text-field v-model="editedItem.name" label="Customer's name"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.nickname" label="Nickname"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.phone" type="number" label="Phone"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.address" label="Address"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <!-- <v-text-field v-model="editedItem.default_driver_id" label="Defauly delivery driver"></v-text-field> -->

                  <v-select
                   
                    item-text="default_driver"
                    item-value="default_driver_id"
                    :items="driverList"
                    v-model="editedItem.default_driver_id"
                    label="Defauly delivery driver"
                    persistent-hint
                    single-line
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="close">Cancel</v-btn>
            <v-btn color="primary" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search Customers"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>
    <p v-if="errors.length">
      <v-alert :value="true" color="error" type="error" dismissible outline>{{ errors }}</v-alert>
    </p>

    <v-data-table :headers="headers" :items="desserts" :search="search" disable-initial-sort  class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr
          :style="{backgroundColor: (props.item.status == '1' ? '#f4424226' : '#ffffff' ) }"
        >
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.nickname }}</td>
        <td class="text-xs-right">{{ props.item.phone }}</td>
        <td class="text-xs-right">{{ props.item.address }}</td>
        <td class="text-xs-right">{{ props.item.default_driver }}</td>
        <td class="justify-end layout px-5">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        </tr>
      </template>

      <v-alert
        slot="no-results"
        :value="true"
        color="primary"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>
    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";

export default {
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    ERROR_corrnnection: false,
    errors: "",
    baseUrl: baseUrl,
    headers: [
      {
        text: "Customer's Name",
        value: "name"
      },
      { text: "Nickname", align: "right", value: "nickname" },
      { text: "Phone", align: "right", value: "phone" },
      { text: "Address", align: "right", value: "address" },
      { text: "Default Driver", align: "right", value: "default_driver_id" },
      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    desserts: [],
    driverList: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      nickname: "",
      phone: 0,
      address: "",
      default_driver_id: ""
    },
    defaultItem: {
      name: "",
      phone: 0,
      address: "",
      default_driver_id: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Customer" : "Edit Customer";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
    this.getDriver();
  },

  methods: {
    initialize() {
      const params = new URLSearchParams();
      params.append("getAllCustomerList", "getAllCustomerList");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.desserts = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getDriver() {
      const params = new URLSearchParams();
      params.append("get_driver", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.driverList = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      var id = item.id;
      var status = item.status;
      const params = new URLSearchParams();
      params.append("customer_id", id);
      params.append("delete_customer", "delete_customer");
      params.append("status", status);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.$emit("customer");
            this.initialize();
            // const index = this.desserts.indexOf(item);
            // this.desserts.splice(index, 1);
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // console.log("edited data");
        // console.log(this.editedItem);

        var id = this.editedItem.id;
        var name = this.editedItem.name;
        var nickname = this.editedItem.nickname;
        var phone = this.editedItem.phone;
        var address = this.editedItem.address;
        var default_driver_id = this.editedItem.default_driver_id;

        const params = new URLSearchParams();
        params.append("customer_id", id);
        params.append("name", name);
        params.append("nickname", nickname);
        params.append("phone", phone);
        params.append("address", address);
        params.append("default_driver", default_driver_id);
        params.append("update_customer", "update_customer");

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/user.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
            this.$emit("customer");
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        });
      } else {
        const params = new URLSearchParams();

        params.append("create_customer", "create_customer");

        params.append("name", this.editedItem.name);
        params.append("nickname", this.editedItem.nickname);
        params.append("phone", this.editedItem.phone);
        params.append("address", this.editedItem.address);
        params.append("default_driver", this.editedItem.default_driver_id);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/user.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
            this.$emit("customer");
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
          this.initialize();
        });
      }
      this.close();
    }
  }
};
</script>

